import { h } from 'preact';

import style from './style';

import { Column, Row, Section } from '@cube/layout';
import { StockTickerBar25, StockTickerBar } from '@cube/finance-components'; // Import both components
import CardHeader from '../card-header';

function TickerFooter({ links }) {
	if (!Array.isArray(links) || links.length === 0) {
		return null;
	}
	const result = (
		<div class={style.tickerFooter}>
			{links.map(link => (
				<CardHeader title={' '} link={link} qeId={link.label}  headerClass={'nomargin'} />
			))}
		</div>
	);
	return result;
}

export function TopBar({ type, links, mode }) { // Add mode prop
	if (type === 'finance') {
		const tickerProps = {
			query: {
				type: 'STOCK',
				list: '+dollarVolume',
				filter: 'MAJORCOMPANIES',
				limit: 10
			}
		};
		if (mode === 'P25') {
			tickerProps.tickerFooter = <TickerFooter links={links} />;
			return <StockTickerBar25 {...tickerProps} />;
		}
		return <StockTickerBar {...tickerProps} />;
        
	}

	// PoC for Armstrong Neighborhood vertical.  Will be reworked later.
	if (type === 'armstrong') {
		return (
			<Section rowClass={style.armstrong}>
				<Row>
					<Column>
						<div class={style.content}>
							<img src="https://vam-image.imds-cdn.com/92/25/92258af93adf8ec34e9c05aec9e82406cd6a191c" />
							<div>
								<div class={style.title}>Welcome to the Armstrong Neighborhood Channel</div>
								<div class={style.description}>Discover original programming for and about your community, produced by award-winning, locally based television professionals. Scroll down to find your neighborhood and begin watching!</div>
							</div>
						</div>
					</Column>
				</Row>
			</Section>
		);
	}
}
